export enum SHIFT_REPEAT_TYPES {
  SINGLE = 'Single',
  WEEKLY = 'Weekly',
  MONTHLY = 'Monthly',
}